/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2021
 * @format
 * @flow
 */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Group, Rect, Circle, Transformer, Text as KonvaText } from 'react-konva';
import tranformerConfig from './tranformerConfig';

const Table8Circle = props => {
  const {
    shapeProps,
    isSelected,
    onSelect,
    onChange,
    draggable,
    tableInfoColumn,
    keyName1,
    keyName2,
    keyName3,
  } = props;
  const { x, y, scaleX, scaleY, rotation, stroke, strokeWidth } = shapeProps;
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (draggable && isSelected) {
      trRef.current.setNode(shapeRef.current);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const onDragEnd = e => {
    onChange && onChange({
      ...shapeProps,
      x: e.target.x(),
      y: e.target.y(),
    });
  };

  const onTransformEnd = e => {
    //transformer is changing scale
    const node = shapeRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    node.scaleX(1);
    node.scaleY(1);
    onChange && onChange({
      ...shapeProps,
      x: node.x(),
      y: node.y(),
      scaleX: scaleX,
      scaleY: scaleY,
      rotation: node.rotation(),
    });
  };

  return (
    <>
      <Group
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        x={x}
        y={y}
        scaleX={scaleX}
        scaleY={scaleY}
        rotation={rotation}
        draggable={draggable}
        onDragEnd={onDragEnd}
        onTransformEnd={onTransformEnd}
      >
        <Rect x={0} y={50} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect rotation={-45} x={5} y={35} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={50} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect rotation={45} x={107} y={7} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={130} y={50} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect rotation={-45} x={98} y={128} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={50} y={130} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect rotation={45} x={12} y={98} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Circle x={70} y={70} stroke={stroke} strokeWidth={strokeWidth} width={120} height={120} radius={60} />
        {tableInfoColumn && <KonvaText text={shapeProps[tableInfoColumn]} x={25} y={60} fill={stroke} fontSize={35} />}
        {keyName1 && <KonvaText text={shapeProps[keyName1]} x={40} y={25} fill={'white'} fontSize={14} />}
        {keyName2 && <KonvaText text={shapeProps[keyName2]} x={40} y={105} fill={'white'} fontSize={14} />}
        {keyName3 && <KonvaText text={shapeProps[keyName3]} x={100} y={60} fill={'white'} fontSize={14} />}
      </Group>
      {draggable && isSelected && <Transformer ref={trRef} {...tranformerConfig} />}
    </>
  );
};

export default Table8Circle;

Table8Circle.propTypes = {
  shapeProps: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  draggable: PropTypes.bool,
  tableInfoColumn: PropTypes.string,
};

Table8Circle.defaultProps = {
  shapeProps: {},
  isSelected: false,
  onSelect: () => { },
  onChange: () => { },
  draggable: true,
};
